import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Button} from "primeng/button";
import {DatePipe, DecimalPipe} from "@angular/common";
import {Dialog} from "primeng/dialog";
import {Fluid} from "primeng/fluid";
import {InputNumber} from "primeng/inputnumber";
import {PrimeTemplate} from "primeng/api";
import {TableModule} from "primeng/table";
import {Forecast} from '../forecast/forecast';
import {ForecastRevisionService} from '../forecast-revision/forecast-revision.service';
import {FormsModule} from '@angular/forms';
import {ForecastRevisionCollection} from '../forecast-revision/forecast-revision-collection';

@Component({
  selector: 'app-revise-forecast-quantity',
    imports: [
        Button,
        DatePipe,
        DecimalPipe,
        Dialog,
        Fluid,
        InputNumber,
        PrimeTemplate,
        TableModule,
        FormsModule
    ],
  templateUrl: './revise-forecast-quantity.html',
  styleUrl: './revise-forecast-quantity.scss',
})
export class ReviseForecastQuantity {

    @Input() public forecast!: Forecast;
    @Output() protected visibleChange = new EventEmitter<boolean>();
    @Output() protected saved = new EventEmitter<void>();

    protected revisedQuantity = 0;
    protected revisions!: ForecastRevisionCollection;

    private _visible = false;

    get visible(): boolean {
        return this._visible;
    }

    @Input() set visible(value: boolean) {
        this._visible = value;

        if (value && this.forecast) {
            Promise.resolve().then(() => {
                this.revisedQuantity = this.forecast.latestRevisedQuantity ?? this.forecast.requestedQuantity;

                this.forecastRevisionService.getRevisions(this.forecast).subscribe(result => {
                    this.revisions = result;
                });
            });
        }
    }

    constructor(
        private forecastRevisionService: ForecastRevisionService,
    ) {
    }

    protected closeModal(): void {
        this.visibleChange.emit(false);
    }

    protected reviseQuantity(): void {
        this.forecastRevisionService
            .createForecastRevision(this.forecast, this.revisedQuantity)
            .subscribe(() => {
                this.saved.emit();
                this.closeModal();
            });
    }
}
